import { ANALYZE_FOR_ENTRY_COMPONENTS, ModuleWithProviders, NgModule } from '@angular/core';

@NgModule({
	declarations: [],
	imports: [],
})
export class CustomDynamicComponentsModule {
	static withComponents(components?: any): ModuleWithProviders<any> {
		return {
			ngModule: CustomDynamicComponentsModule,
			providers: [{ provide: ANALYZE_FOR_ENTRY_COMPONENTS, useValue: components, multi: true }],
		};
	}
}
